const gridContainerConfig = {
	maxWidth: '128rem',
};

// minWidth and maxWidth use default browser setting hence different calculation
// calculation explanation:
// (x * 0.625). x - normal rem (using root value);
// 0.625 - accommodate for the use of default setting from browser
const gridConfig = {
	xxs: {
		gutter: '0.8rem',
		margin: '1.6rem',
		maxWidth: `${35.9 * 0.625}rem`,
		minWidth: '0rem',
	},
	xs: {
		gutter: '0.8rem',
		margin: '1.6rem',
		maxWidth: `${37.4 * 0.625}rem`,
		minWidth: `${36 * 0.625}rem`,
	},
	s: {
		gutter: '0.8rem',
		margin: '1.6rem',
		maxWidth: `${76.7 * 0.625}rem`,
		minWidth: `${37.5 * 0.625}rem`,
	},
	m: {
		gutter: '1.2rem',
		margin: '2.4rem',
		maxWidth: `${102.3 * 0.625}rem`,
		minWidth: `${76.8 * 0.625}rem`,
	},
	l: {
		gutter: '1.2rem',
		margin: '2.4rem',
		maxWidth: `${143.9 * 0.625}rem`,
		minWidth: `${102.4 * 0.625}rem`,
	},
	xl: {
		gutter: '1.6rem',
		margin: '8rem',
		maxWidth: `${191.9 * 0.625}rem`,
		minWidth: `${144 * 0.625}rem`,
	},
	xxl: {
		gutter: '1.6rem',
		margin: '8rem',
		maxWidth: '',
		minWidth: `${192 * 0.625}rem`,
	},
};

export { gridContainerConfig, gridConfig };
